import React, { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Link, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthProvider';
import Navbar from '../Pages/Shared/Navbar/Navbar';
import app from '../firebase/firebase.config'
import {useAuthState} from 'react-firebase-hooks/auth'
import {getAuth} from 'firebase/auth'
const DashboardLayout = () => {
    const auth = getAuth(app)
   
    const {userDb} = useContext(AuthContext)
 
      //console.log(userDb);
    return (
        <div>
            <Navbar></Navbar>
            <div className="drawer drawer-mobile">
            <input id="dashboard-drawer" type="checkbox" className="drawer-toggle" />
            <div className="drawer-content">
                <Outlet></Outlet>
            </div> 
            <div className="drawer-side">
                <label htmlFor="dashboard-drawer" className="drawer-overlay"></label> 
                <ul className="menu p-4 w-80 bg-base-100 text-xl">
                    {
                        userDb.role === "Buyer" && <>
                         <li><Link to="/dashboard/buyer">My Orders</Link></li>
                        </>
                    }
                       {
                        userDb.role === "Seller" && <>
                          <li className='mt-2'><Link to="/dashboard/seller/addproduct">Add Product</Link></li>
                          <li className='mt-2'><Link to="/dashboard/seller/myproduct">My Products</Link></li>
                        </>
                    }
                    {
                      userDb.role === "Admin" && <>
                        <li className='mt-2'><Link to="/dashboard/allusers">Admin</Link></li>
                        <li className='mt-2'><Link to="/dashboard/seller">Seller</Link></li>
                        <li><Link to="/dashboard/buyer">Buyer</Link></li>
                     </>   
                    }
                   
                </ul>
            
            </div>
            </div>
        </div>
    );
};

export default DashboardLayout;